<!-- eslint-disable -->
<template>
  <div>
    <div>
      <div v-if="loginType !== 'createUser'" class='p7_buttons_container'>
        <button @click.prevent="loginType = 'passwordlessLogin'">
          Email Login
        </button>
        <button @click.prevent="loginType = 'emailPasswordLogin'">
          Email & Password Login
        </button>
      </div>
      
      <!-- ----------  Modals ---------- -->
      <div class="G_box p7_login_modal">
        <div class="p7_grid_item2" v-if="loginType === 'passwordlessLogin'">
          <form>
            <h2 class="p7_passwordless_modal_header"></h2>
            <input 
              @keydown.13="passwordlessSignIn" 
              class="p7_input" 
              type="text" 
              v-model.trim="email" 
              placeholder="Email"
            >
            <input class="G_hidden_element" type="text">
            <label v-if="emailError" class="p7_error_text p7_bad_email_error"></label>
          </form>
          <button 
            class="p7_send_sign_in_email_btn" 
            @click="passwordlessSignIn"
          ></button>
        </div>

        <div class="p7_grid_item2" v-if="loginType === 'emailPasswordLogin'">
          <form>
            <h2 class="p7_password_modal_header"></h2>
            <input 
              class="p7_input" 
              type="text" 
              v-model.trim="email" 
              placeholder="Email"
            >
            <label 
              v-if="emailError" 
              class="p7_error_text p7_bad_email_error"
            ></label>
            <br>
            <input 
              @keydown.13="passwordSignIn" 
              class="p7_input" 
              type="password" 
              v-model.trim="password" 
              placeholder="Password"
            >
            <label 
              v-if="passwordError" 
              class="p7_error_text p7_bad_password_error"
            ></label>
          </form>
            <div>
              <button 
                class="p7_password_login_btn" 
                @click="passwordSignIn"
              ></button>
              <button 
                class="p7_reset_password_btn" 
                @click="resetPassword"
              ></button>
            </div>
        </div>

        <div class="p7_create_user_modal" v-if="loginType === 'createUser'">
          <h1>Account Not Found</h1>
          <div class="p7_create_user_modal_body">
            <p>No WebGUI account was found for your email address.</p>
            <p>Please visit <a :href="getDGNetSiteUrl">DGNet Watchdog</a> to create your account and contact your account administrator to add WebGUI.</p>
            <p>OR</p>
            <p>Try with a different email address.</p>
          </div>
          <button @click.stop="loginType = 'emailPasswordLogin'">Try Again</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import base_i3_log from '@/watchdog_includes/base_i3_logging'
import AWN from "awesome-notifications";

export default {
  name: "p7FirebaseLogin",
  data() {
    return {
      email: '',
      password: '',
      emailError: false,
      passwordError: false,
      loginType: "passwordlessLogin",
    };
  },
  methods: {
    gotoHome() {
      window.G_vue_instance.$router.push('/');
    },
    resetPassword() {
      window.G_firebase_auth.bi5ResetPassword(this.email.toLowerCase())
    },
    passwordSignIn() {
      window.G_firebase_auth.bi5AttemptPasswordSignIn(this.email.toLowerCase(), this.password)
      return false;
    },
    passwordlessSignIn() {
      window.G_firebase_auth.bi5AttemptPasswordlessSignIn(this.email.toLowerCase())
      return false;
    },
    signingInFeedback() {
      this.$awn.info('Loading Account Information.')
    },
    signedInCallback() {
      if (window.G_redirectUrl !== null) {
        //copy the simple object string into a new variable and delete the redirect, this way if the replace fails they aren't in an inifite loop
        const redirectUrl = window.G_redirectUrl;
        window.G_redirectUrl = null;
        window.G_vue_instance.$router.push(redirectUrl);
        return;
      }

      if (window.location.search === null || window.location.search === undefined || window.location.search === "") {
        window.G_vue_instance.$router.replace("/dashboard");
        return;
      }

      // this will redirect if user logged in using email/password and have redirect url.
      if (window.location.search.indexOf('apiKey') < 0 && window.location.search.includes("redirect_to=")) {
        // Extracting redirect path from query string
        const redirect_to = window.location.origin + "/" + decodeURIComponent(window.location.search).split("redirect_to=")[1]
        window.location.replace(redirect_to)
        return;
      }

      // this will redirect if user logged in using direct email link and get the continue url.
      if (window.location.search.indexOf('apiKey') > 0 && window.location.search.includes("continueUrl=")) {
        const continue_url = decodeURIComponent(window.location.search).split("continueUrl=")[1]
        const redirect_to = window.location.origin + "/" + decodeURIComponent(continue_url).split("redirect_to=")[1]
        window.location.replace(redirect_to)
        return;
      }

      // this will redirect if user logged in using direct email link and get the redirect url.
      if (window.location.search.indexOf('apiKey') > 0 && window.location.search.includes("continueUrl=") == false && window.location.search.includes("redirect_to=")) {
        const redirect_to_path = decodeURIComponent(window.location.search).split("&apiKey=")[0];
        const redirect_to = window.location.origin + "/" + redirect_to_path.split("redirect_to=")[1]
        window.location.replace(redirect_to)
        return;
      }

      window.G_vue_instance.$router.replace("/dashboard");
    },
    passwordlessEmailSent() {
      this.$awn.info('You should receive a sign in link in your email shortly.')
    },
    passwordlessEmailSendFailed(error) {
      this.$awn.alert("Error sending email:" + error)
    },
    emailValid() {
      this.emailError = false
    },
    emailNotValid() {
      this.emailError = true
    },
    signInFailedCallback(error) {
      const CI = this;
      if (error[0].code === 'auth/user-not-found'){
        CI.password = ''
        CI.loginType = 'createUser'
      }
      if (error[0].code === 'auth/wrong-password'){
        CI.password = ''
        CI.$awn.alert('Incorrect password. Please try again.')
      }
        
      CI.$awn.alert("sign in failed with error:" + JSON.stringify(error))
    },
    passwordNotValid() {
      this.passwordError = true
    },
    passwordValid() {
      this.passwordError = false
    },
    passwordResetSent() {
      this.$awn.info('You should receive a password reset email shortly.')
    },
    passwordResetFailed() {
      this.$awn.alert("password reset failed with errorr:" + JSON.stringify(error))
    },
    automaticUserCreation() {
      const CI = this;
      const debug_data = [];
      let return_msg = "p7login:automaticUserCreation ";
      const task_id = "p7login:automaticUserCreation";
      const base64_email_address = CI.$route.params['newUserEmail'];
      const base64_password = CI.$route.params['newUserPassword'];
      if (typeof base64_email_address !== 'string' || typeof base64_password !== 'string') {
        return;
      }
      CI.password = base64_password;

      try {
        CI.email = atob(base64_email_address)
      } catch(error) {
        return_msg += "failed to convert base64 encoded strings with error:" + JSON.stringify(error);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return;
      }
      const date_object = new Date();
      window.G_firebase_auth.bi5CreateUser(CI.email.toLowerCase(), CI.password);
    },
  },
  mounted() {
    const CI = this;
    CI.$nextTick(function() {
      window.G_firebase_auth.bi5SetLoginPageCallbacks(
        CI.signingInFeedback,
        CI.signedInCallback,
        CI.signInFailedCallback,
        CI.passwordlessEmailSent,
        CI.passwordlessEmailSendFailed,
        CI.emailValid,
        CI.emailNotValid,
        CI.passwordValid,
        CI.passwordNotValid,
        null,
        CI.passwordResetSent,
        CI.passwordResetFailed
      );

      //if the user is already signed in skip the login screen
      if (window.G_firebase_auth.IV_token_verified === true && window.G_firebase_auth.IV_is_guest === false) {
        CI.signedInCallback();
        return;
      }
      //if the user was signing out reset the signout requested flag
      if (window.G_firebase_auth.IV_signout_requested_flag === true) {
        window.G_firebase_auth.IV_signout_requested_flag = false;
      }
      if ('newUserEmail' in CI.$route.params && 'newUserPassword' in CI.$route.params) {
        //the 2 second delay is to allow time for firebase to auth with an existing account, so that an attempt isn't made to recreate an account
        setTimeout(CI.automaticUserCreation, 2000);
      }
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/public/Login.vue